import type { AppConfig } from '@/src/config/schema';
import { defaultFeatureFlags } from '../../profiles/profile.schema';

export const defaultAppConfig: AppConfig = {
  privacy: {
    anonymize: false,
  },
  features: defaultFeatureFlags,
};
